import { topicsData } from '@/mocks/homeData';

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-8 text-center">
          {topicsData.title}
        </h2>
        <div className="flex flex-wrap gap-3 justify-center">
          {topicsData.items.map((item) => (
            <div
              key={item.name}
              className="group flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-100 hover:bg-primary-100 border border-background-200/60 hover:border-primary-300 transition-all duration-200 cursor-pointer"
            >
              {item.trending && (
                <i className="ri-fire-line text-accent-500 text-sm"></i>
              )}
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-700 whitespace-nowrap">
                {item.name}
              </span>
              <span className="text-xs text-foreground-400 whitespace-nowrap">{item.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}